var map = {
	"./bl_caution.png": "9071",
	"./bl_good.png": "3469",
	"./bl_health.png": "df6f",
	"./bl_line.png": "23ff",
	"./bl_warning.png": "c933",
	"./br_caution.png": "dc29",
	"./br_good.png": "c221",
	"./br_health.png": "56f2",
	"./br_line.png": "5b69",
	"./br_warning.png": "334c",
	"./empty_teeth.png": "5c47",
	"./grey_empty_teeth.png": "43a5",
	"./img_caution.png": "539d",
	"./img_good.png": "2a80",
	"./img_health.png": "1c5d",
	"./img_warning.png": "3743",
	"./tl_caution.png": "682c",
	"./tl_good.png": "8c7d",
	"./tl_health.png": "e79c",
	"./tl_line.png": "7aae",
	"./tl_warning.png": "bb62",
	"./tr_caution.png": "fb46",
	"./tr_good.png": "44b1",
	"./tr_health.png": "35f5",
	"./tr_line.png": "e431",
	"./tr_warning.png": "996c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "687c";